module.exports = __webpack_public_path__ + "static/media/truckerpath.24578db6.png";